export default function addEventToDataLayer({ category, label, action = 'click' }: { category: string; label: string; action?: string }) {
  if (window?.dataLayer) {
    window.dataLayer.push({
      stckEventCategory: category,
      stckEventLabel: label,
      stckEventAction: action,
      event: 'stck',
    });
  }
}
